module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": 'imbee-' + _vm.bubble.bubbleTransition,
      "enter-active-class": 'imbee-' + _vm.bubble.bubbleInTransition,
      "leave-active-class": 'imbee-' + _vm.bubble.bubbleOutTransition
    },
    on: {
      "after-enter": function () {
        _vm.showBadges = true;
      },
      "before-leave": function () {
        _vm.showBadges = false;
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bubble.show),
      expression: "bubble.show"
    }],
    staticClass: "w-imbee-bubble",
    style: (( _obj = {
      bottom: _vm.bubble.verticalPadding
    }, _obj[_vm.alignment] = _vm.bubble.horizontalPadding, _obj.color = _vm.bubble.color, _obj.backgroundColor = _vm.bubble.backgroundColor, _obj )),
    attrs: {
      "data-opened": _vm.opened
    },
    on: {
      "click": _vm.clicked
    }
  }, [_c('TextBadge', {
    attrs: {
      "opened": _vm.opened,
      "show": _vm.textBadge.show && _vm.showBadges,
      "text": _vm.textBadge.text,
      "color": _vm.textBadge.color,
      "background-color": _vm.textBadge.backgroundColor,
      "font-size": _vm.textBadge.fontSize,
      "font-family": _vm.textBadge.fontFamily,
      "font-weight": _vm.textBadge.fontWeight,
      "show-cta": _vm.showCta,
      "animation": _vm.textBadge.animation
    }
  }), _vm._v(" "), _c('CloseCross', {
    attrs: {
      "opened": _vm.opened,
      "show": _vm.closeCross.show,
      "color": _vm.closeCross.color,
      "background-color": _vm.closeCross.backgroundColor,
      "font-size": _vm.closeCross.fontSize,
      "font-family": _vm.closeCross.fontFamily,
      "font-weight": _vm.closeCross.fontWeight,
      "show-cta": _vm.showCta,
      "size": _vm.closeCross.size,
      "top": _vm.closeCross.top,
      "right": _vm.closeCross.right
    },
    on: {
      "~crossclicked": function($event) {
        return _vm.handleCrossClicked.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('Badge', {
    attrs: {
      "show": _vm.badge.show && _vm.showBadges,
      "text": _vm.badge.text,
      "color": _vm.badge.color,
      "background-color": _vm.badge.backgroundColor
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "imbee-fade",
      "mode": "out-in"
    }
  }, [(_vm.bubble.showImage && !_vm.opened) ? _c('div', {
    staticClass: "w-imbee-bubble-image-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.bubble.image,
      "alt": "Chat image"
    }
  })]) : (!_vm.opened) ? _c('svg', {
    key: "open",
    attrs: {
      "width": "37.973",
      "viewBox": "0 0 841.89 749.55",
      "height": "42",
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M485.005 655.933H49.375s30.635-9.693 61.269-49.635C141.666 566.36 172.3 496.162 172.3 374.78c0-155.501 126.041-281.163 281.152-281.163h32.441-14.24c155.278 0 281.154 125.888 281.154 281.163 0 155.274-125.876 281.152-281.154 281.152M336.84 330.918c-24.781 0-44.853 20.081-44.853 44.854 0 24.771 20.071 44.854 44.853 44.854 24.771 0 44.843-20.083 44.843-44.854 0-24.773-20.072-44.854-44.843-44.854zm124.834 0c-24.769 0-44.851 20.081-44.851 44.854 0 24.771 20.083 44.854 44.851 44.854 24.772 0 44.854-20.083 44.854-44.854-.001-24.773-20.082-44.854-44.854-44.854zm127.26 0c-24.773 0-44.854 20.081-44.854 44.854 0 24.771 20.08 44.854 44.854 44.854 24.768 0 44.851-20.083 44.851-44.854-.001-24.773-20.084-44.854-44.851-44.854z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.opened && _vm.bubble.closeIcon == 1) ? _c('Close1') : _vm._e(), _vm._v(" "), (_vm.opened && _vm.bubble.closeIcon == 2) ? _c('Close2') : _vm._e(), _vm._v(" "), (_vm.opened && _vm.bubble.closeIcon == 3) ? _c('Close3') : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4076f930"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bubble.vue
// module id = 210
// module chunks = 0 1